import firebase from '@firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/analytics'
  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyCEW_bIN_gwnAGRlEwPf7THYmTuzjOmVTg",
  authDomain: "vergeo-21ffc.firebaseapp.com",
  databaseURL: "https://vergeo-21ffc.firebaseio.com",
  projectId: "vergeo-21ffc",
  storageBucket: "vergeo-21ffc.appspot.com",
  messagingSenderId: "407980557263",
  appId: "1:407980557263:web:b633531b3bf457a23d88ba",
  measurementId: "G-VVYY6F90YG"
  }

const fb = firebase.initializeApp(config)
const db = firebase.firestore()
const auth = firebase.auth()
const ath = firebase.auth
const anlyt = firebase.analytics()

firebase.firestore().enablePersistence()
.catch(function(err) {
  if (err.code == 'failed-precondition') {
      alert('multitabs opened!')
  } else if (err.code == 'unimplemented') {
      alert('not implemented!')
  }
})

export { fb, db, ath, auth, anlyt }
export default firebase

